import { render, staticRenderFns } from "./klp48-audio-player.vue?vue&type=template&id=754e789d&scoped=true&"
import script from "./klp48-audio-player.vue?vue&type=script&lang=js&"
export * from "./klp48-audio-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e789d",
  null
  
)

export default component.exports